export default {
  settings: {
    hasOvertime: true,
    hasShootouts: true,
    hasCustomStatistic: true
  },
  modules: {
    info: [
      'timer',
      {
        type: 'players',
        props: {
          home: ingameData => ingameData.playersCount.home,
          away: ingameData => ingameData.playersCount.away
        }
      },
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      score: ingameData => ingameData.score
    },
    fieldScheme: {
      component: 'football-field'
    },
    eventLog: true
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    playersCount: {
      home: 5,
      away: 5
    },
    hasTimer: false,
    shootoutsLog: {
      home: [],
      away: []
    },
    getOvertimePeriodName: (num) => num
  }
}
